const convertDateStringToThDateString = (dateString) => {
    const dateStringArray = dateString.split('-')
    const yearFullTh = parseInt(dateStringArray[0]) + 543
	const monthTh = parseInt(dateStringArray[1])
    const day = dateStringArray[2]
    const yearTh = yearFullTh-2500
    const thMonthShort = ['', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.' ]
    if ( typeof thMonthShort[monthTh] == 'undefined' ) {
        return null
    }
    const monthStr = thMonthShort[monthTh]
    const dateStr = `${day} ${monthStr} ${yearTh}`;
    return dateStr
}

export default convertDateStringToThDateString;